export const getCompanyMetadata = state => state.companyMetadata;
